module.exports = "../../static/img/logo-symbol.4451361.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo-symbol.png
// module id = 1331
// module chunks = 0